import {
  INITIALIZE_FOLDERS,
  SET_CURRENT_PATH,
  SET_FOLDER_TREE,
  SET_SNACKBAR,
} from './folderActionsType';

export const initializeFolders = (foldersInfo) => {
  return {
    type: INITIALIZE_FOLDERS,
    foldersInfo,
  };
};
export const setFolderTree = (folders) => {
  return {
    type: SET_FOLDER_TREE,
    folders,
  };
};
export const setFoldersCurrentPath = (currentPath) => {
  return {
    type: SET_CURRENT_PATH,
    currentPath,
  };
};
export const setSnackbar = (snackbar) => {
  return {
    type: SET_SNACKBAR,
    snackbar,
  };
};
